/**
 * Free Shipping Bar functionality
 * Uses Web Components like Infanti theme for automatic updates
 */

if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateBar();
    }

    updateBar() {
      const total = parseInt(this.dataset.cartTotal, 10);
      const minimum = parseInt(this.dataset.minimum, 10);
      
      if (!total || !minimum) return;

      const percentage = Math.min((total / minimum) * 100, 100);
      const remainingAmount = Math.max(minimum - total, 0);
      
      // Update progress bar
      const progressBar = this.querySelector('.free-shipping-bar__progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }

      // Update messages
      const remainingMessage = this.querySelector('.free-shipping-bar__message--remaining');
      const achievedMessage = this.querySelector('.free-shipping-bar__message--achieved');

      if (total >= minimum) {
        // Show achieved message, hide remaining message
        if (remainingMessage) {
          remainingMessage.style.display = 'none';
        }
        if (achievedMessage) {
          achievedMessage.style.display = 'block';
        }
      } else {
        // Show remaining message, hide achieved message
        if (remainingMessage) {
          remainingMessage.style.display = 'block';
          // Update the amount in the message
          const amountElement = remainingMessage.querySelector('strong');
          if (amountElement) {
            amountElement.textContent = this.formatMoney(remainingAmount);
          }
        }
        if (achievedMessage) {
          achievedMessage.style.display = 'none';
        }
      }

      // Update data attributes for future updates
      this.dataset.cartTotal = total;
    }

    formatMoney(amount) {
      // Use Shopify's money format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(amount);
      }
      
      // Use theme's currency formatter if available
      if (window.theme && window.theme.Currency && window.theme.settings) {
        return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
      }
      
      // Fallback formatting
      return (amount / 100).toLocaleString('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
      });
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}

// Function to update cart total and refresh all bars
function updateFreeShippingBars(cartTotal = null) {
  // Get current cart total if not provided
  if (!cartTotal) {
    const cartDrawer = document.getElementById('CartDrawer');
    const subtotalElement = cartDrawer?.querySelector('[data-subtotal]');
    if (subtotalElement) {
      // Extract number from money format (e.g., "$1,250" -> 125000)
      const moneyText = subtotalElement.textContent.trim();
      const numberMatch = moneyText.match(/[\d,]+/);
      if (numberMatch) {
        cartTotal = parseInt(numberMatch[0].replace(/,/g, '')) * 100;
      }
    }
  }

  // Update all free shipping bars
  document.querySelectorAll('free-shipping-bar').forEach(bar => {
    if (cartTotal) {
      bar.dataset.cartTotal = cartTotal;
    }
    if (bar.updateBar) {
      bar.updateBar();
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize any existing bars
  document.querySelectorAll('free-shipping-bar').forEach(bar => {
    if (bar.updateBar) {
      bar.updateBar();
    }
  });
});

// Also initialize on page load
document.addEventListener('page:loaded', () => {
  // Initialize any existing bars
  document.querySelectorAll('free-shipping-bar').forEach(bar => {
    if (bar.updateBar) {
      bar.updateBar();
    }
  });
});

// Listen for cart updates to update all bars
document.addEventListener('cart:updated', (event) => {
  if (event.detail && event.detail.cart) {
    updateFreeShippingBars(event.detail.cart.total_price);
  }
});

// Listen for cart quantity changes
document.addEventListener('cart:quantity.cart-drawer', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 100);
});

document.addEventListener('cart:quantity.cart-header', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 100);
});

// Listen for product added to cart - this is the key event
document.addEventListener('ajaxProduct:added', (event) => {
  // Wait for cart drawer to rebuild and then update
  setTimeout(() => {
    updateFreeShippingBars();
  }, 800);
});

// Listen for cart drawer open
document.addEventListener('drawerOpen.CartDrawer', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 100);
});

// Listen for cart open
document.addEventListener('cart:open', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 100);
});

// Additional event listeners for cart rebuild
document.addEventListener('cart:build', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 200);
});

// Listen for drawer open to catch when cart drawer is re-rendered
document.addEventListener('drawerOpen', () => {
  setTimeout(() => {
    updateFreeShippingBars();
  }, 200);
});

// Observe cart drawer for changes
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && 
            (mutation.target.closest('[data-products]') || 
             mutation.target.closest('[data-subtotal]'))) {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        setTimeout(() => {
          updateFreeShippingBars();
        }, 100);
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
});
